export default {
    CHANGE_CHAIN_ID: 'changeChainId',
    CHANGE_ALLOW: 'changeAllow',
}